import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select } from 'antd';

export interface IPaymentMethodSelectProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  onChange: (e: any, method: GQL.IPaymentMethod | undefined) => void;
  value: string | undefined;
  methods?: Array<GQL.IPaymentMethod>;
  style?: any;
}

export class PaymentMethodSelect extends React.PureComponent<IPaymentMethodSelectProps> {

  constructor(props: IPaymentMethodSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, methods } = this.props;

    if (methods) {
      return (
        <Select
          placeholder={'Choose payment method'}
          onChange={this.onChange}
          value={value}
          style={...style}
        >
          {methods.map(l => {
            return (
              <Select.Option key={l.id} value={l.id}>
                {l.title}
              </Select.Option>
            );
          })}
        </Select>
      );
    }

    return (
      <Select placeholder={'Choose payment method'} style={...style} />
    );
  }

  private onChange(value: string) {
    const { methods } = this.props;

    const method = methods && methods.find((l: GQL.IPaymentMethod) => l.id === value);

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      }, method);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/PaymentMethodSelect/PaymentMethodSelect.tsx